import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";

interface GymNameFieldProps {
  gymName: string;
  setGymName: (name: string) => void;
  isEditing: boolean;
}

export const GymNameField = ({
  gymName,
  setGymName,
  isEditing,
}: GymNameFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="gymName" className="flex items-center gap-2 text-muted-foreground">
        <Building2 className="h-4 w-4" />
        Nombre del Gimnasio
      </Label>
      <Input
        id="gymName"
        value={gymName}
        onChange={(e) => setGymName(e.target.value)}
        disabled={!isEditing}
        placeholder="Ingresa el nombre del gimnasio"
        className="bg-background/50 border-input/50 focus:border-primary focus:bg-background transition-all"
      />
    </div>
  );
};